import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// ── Klil 1700 Profile Weights ──
const PW_1700 = {
    '04911': 1.050, '04917': 1.150, '04957': 0.890, '04909': 0.780, '04910': 0.780,
    '04914': 0.850, '04915': 0.850, '04903': 0.540, '04901': 0.480, '04902': 0.520,
    '04933': 0.580, '04931': 0.520, '04932': 0.560, '04918': 0.650, '04952': 0.720,
    '04920': 0.680, '04707': 0.450, '04962': 0.700, '04924': 1.250, '04925': 1.150,
    '04923': 0.950, '04921': 0.550, '03358': 0.149,
};

// ── Klil 9000 Profile Weights ──
const PW_9000 = {
    '03443': 1.150, '06175': 1.250, '03666': 0.850, '03449': 1.050,
    '03446': 1.450, '03448': 1.550, '03447': 0.950,
    '03437': 0.980, '03996': 0.880, '03465': 1.020, '03997': 0.920,
    '03439': 1.100, '03998': 1.000, '03358': 0.149,
    '04188': 1.200, '03450': 1.150, '04260': 0.900, '03966': 1.050,
    '03522': 1.150, '03524': 1.450, '06180': 1.650,
};

// ── Klil 7000 Profile Weights ──
const PW_7000 = {
    '03309': 0.850, '03307': 0.950, '03308': 0.750,
    '03304': 0.800, '03303': 0.700, '03305': 0.850,
    '03469': 0.800, '03337': 0.850, '03336': 0.750, '03338': 0.900,
    '03317': 0.950, '03947': 1.050, '03329': 0.850,
    // Screen specific profiles
    '04520': 0.900, '04268': 0.800,
    // Door Profiles
    '04193': 1.050, '03694': 1.100, '03695': 0.950,
    '04975': 1.200, '04741': 1.300, '04974': 1.100,
    '04981': 1.400, '04982': 1.500, '04980': 1.200,
    '04523': 1.000, '04522': 1.150,
    '06180': 1.650, '03358': 0.149, '03911': 0.120, '04973': 0.950, '03836': 0.850,
};

// Round to 1 decimal to avoid floating-point display issues (e.g. 595.4000000000004)
const rd = (v) => Math.round(v * 10) / 10;

// ────────────────────── Calculator Logic (1700) ──────────────────────
function calc1700(L, H, wings, glassType, shutter, fixedPart, H2) {
    const H1 = fixedPart !== 'none' ? H - H2 : H;
    const pSashTB = glassType === '10-14' ? '04933' : '04903';
    const pSashSide = glassType === '10-14' ? '04931' : '04901';
    const pInterlock = glassType === '10-14' ? '04932' : '04902';

    let frame = [], fixedProfiles = [], sash = [], glassParts = [];
    const trims = [
        { desc: 'הלבשה - רוחב', profile: '03358', qty: 2, cut: L + 50 },
        { desc: 'הלבשה - גובה', profile: '03358', qty: 2, cut: H + 50 },
    ];

    if (wings === 2) {
        let topTrack = shutter ? '04917' : '04911';
        let bottomTrack = '04957';
        let jamb = shutter ? '04914 / 04915' : '04909 / 04910';
        let trackCut = rd(shutter ? L - 73 : L - 27);
        let sashWCut = rd(shutter ? (L / 2) - 41 : (L / 2) - 17.5);
        let sashHCut = rd(H1 - 68);

        if (fixedPart === 'bottom' || fixedPart === 'top') {
            frame.push({ desc: 'מסילה עליונה', profile: topTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'חציץ מעבר לקבוע', profile: '04918', qty: 1, cut: L - 27 });
            frame.push({ desc: 'מסילה תחתונה', profile: '04952', qty: 1, cut: L - 27 });
            frame.push({ desc: 'מזוזה', profile: jamb, qty: 2, cut: H });
            fixedProfiles.push({ desc: 'קבוע צד', profile: '04920', qty: 2, cut: H2 - 17 });
            fixedProfiles.push({ desc: 'קבוע אמצעי', profile: '04707', qty: 1, cut: fixedPart === 'top' ? H2 - 7 : H2 - 17 });
            sashHCut = rd(fixedPart === 'top' ? H1 - 98.5 : H1 - 76);
        } else {
            frame.push({ desc: 'מסילה עליונה', profile: topTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'מסילה תחתונה', profile: bottomTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'מזוזה', profile: jamb, qty: 2, cut: H });
        }
        sash.push({ desc: 'כנף עליון/תחתון', profile: pSashTB, qty: 4, cut: sashWCut });
        sash.push({ desc: 'כנף צד', profile: pSashSide, qty: 2, cut: sashHCut });
        sash.push({ desc: 'שולב', profile: pInterlock, qty: 2, cut: sashHCut });
        glassParts.push({ desc: 'זכוכית כנף', qty: 2, text: `${(sashWCut - 35.5).toFixed(1)} x ${(sashHCut - 69).toFixed(1)}` });
        if (fixedPart !== 'none') glassParts.push({ desc: 'זכוכית קבוע', qty: 2, text: `${((L / 2) - 55).toFixed(1)} x ${(H2 - 27).toFixed(1)}` });
    } else if (wings === 3) {
        frame = [
            { desc: 'מסילה עליונה (3)', profile: '04924', qty: 1, cut: L - 27 },
            { desc: 'מסילה תחתונה (3)', profile: '04925', qty: 1, cut: L - 27 },
            { desc: 'מזוזה (3)', profile: '04923', qty: 2, cut: H },
        ];
        let sashWCut = rd((L / 3) - 3);
        sash = [
            { desc: 'כנף עליון/תחתון', profile: pSashTB, qty: 6, cut: sashWCut },
            { desc: 'כנף צד', profile: pSashSide, qty: 2, cut: H1 - 68 },
            { desc: 'שולב', profile: pInterlock, qty: 4, cut: H1 - 68 },
        ];
        glassParts.push({ desc: 'זכוכית כנף', qty: 3, text: `${(sashWCut - 36).toFixed(1)} x ${(H1 - 137).toFixed(1)}` });
    } else if (wings === 4) {
        frame = [
            { desc: 'מסילה עליונה', profile: '04911', qty: 1, cut: L - 27 },
            { desc: 'מסילה תחתונה', profile: '04957', qty: 1, cut: L - 27 },
            { desc: 'מזוזה', profile: '04910', qty: 2, cut: H },
        ];
        let sashWCut = rd((L / 4) - 10);
        sash = [
            { desc: 'כנף עליון/תחתון', profile: pSashTB, qty: 8, cut: sashWCut },
            { desc: 'כנף צד', profile: pSashSide, qty: 4, cut: H1 - 68 },
            { desc: 'שולב', profile: pInterlock, qty: 4, cut: H1 - 68 },
            { desc: 'נעילת פגישה', profile: '04921', qty: 1, cut: H1 - 68 },
        ];
        glassParts.push({ desc: 'זכוכית כנף', qty: 4, text: `${(sashWCut - 35).toFixed(1)} x ${(H1 - 137).toFixed(1)}` });
    }

    let weight = 0;
    [...frame, ...fixedProfiles, ...sash, ...trims].forEach(item => {
        const kgPerMeter = PW_1700[item.profile] || 0;
        weight += (item.cut / 1000) * item.qty * kgPerMeter;
    });

    return {
        frame, fixedProfiles, sash, trims, glassParts, weight: weight.toFixed(2),
        frameW: frame.find(r => r.qty === 1)?.cut || frame[0]?.cut || 0,
        frameH: frame.find(r => r.qty === 2)?.cut || 0,
        sashW: sash[0]?.cut || 0,
        sashH: sash[1]?.cut || 0,
    };
}

// ────────────────────── Calculator Logic (9000) ──────────────────────
function calc9000(L, H, wings, glassType, shutter, fixedPart, H2, type = 'window', widePanel = false) {
    const H1 = fixedPart !== 'none' ? H - H2 : H;
    const pSashTB = glassType === '14-24' ? '03437' : '03996';
    const pSashSide = glassType === '14-24' ? '03465' : '03997';
    const pInterlock = glassType === '14-24' ? '03439' : '03998';

    let frame = [], fixedProfiles = [], sash = [], glassParts = [];
    const trims = [
        { desc: 'הלבשה - רוחב', profile: '03358', qty: 2, cut: L + 50 },
        { desc: 'הלבשה - גובה', profile: '03358', qty: 2, cut: H + 50 },
    ];

    if (wings === 2) {
        let topTrack = shutter ? '04188' : '03443';
        let bottomTrack = type === 'door' ? '03524' : '06175';
        let trackDesc = type === 'door' ? 'מסילה תחתונה (רצפתית לדלת)' : 'מסילה תחתונה';
        let jamb = '03666';
        let trackCut = rd(L - 26);
        let sashWCut = rd((L / 2) - 12);
        let sashHCut = rd(type === 'door' ? H1 - 39.5 : H1 - 80.5);
        if (glassType !== '14-24') sashHCut = rd(sashHCut + 10.7);

        if (fixedPart === 'bottom' || fixedPart === 'top') {
            frame.push({ desc: 'מסילה עליונה', profile: topTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'חציץ מעבר לקבוע', profile: '03966', qty: 1, cut: L - 26 });
            frame.push({ desc: trackDesc, profile: bottomTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'מזוזה כולל קבוע', profile: '03449', qty: 2, cut: H });
            fixedProfiles.push({ desc: 'קבוע צד', profile: '03450', qty: 2, cut: H2 - 17 });
            sashHCut = rd(type === 'door' ? H1 - 47.8 : H1 - 88.8);
        } else {
            frame.push({ desc: 'מסילה עליונה', profile: topTrack, qty: 1, cut: trackCut });
            frame.push({ desc: trackDesc, profile: bottomTrack, qty: 1, cut: trackCut });
            frame.push({ desc: 'מזוזה', profile: jamb, qty: 2, cut: H });
        }

        if (type === 'door' && widePanel) {
            sash.push({ desc: 'כנף עליון', profile: pSashTB, qty: 2, cut: sashWCut });
            sash.push({ desc: 'פנל תחתון רחב', profile: '06180', qty: 2, cut: sashWCut });
        } else {
            sash.push({ desc: 'כנף עליון/תחתון', profile: pSashTB, qty: 4, cut: sashWCut });
        }
        sash.push({ desc: 'כנף צד', profile: pSashSide, qty: 2, cut: sashHCut });
        sash.push({ desc: 'שולב', profile: pInterlock, qty: 2, cut: sashHCut });

        let glassH = (type === 'door' && widePanel) ? sashHCut - 106 : sashHCut - 12;
        glassParts.push({ desc: 'זכוכית כנף', qty: 2, text: `${(sashWCut - 66).toFixed(1)} x ${glassH.toFixed(1)}` });
        if (fixedPart !== 'none') glassParts.push({ desc: 'זכוכית קבוע', qty: 2, text: `${((L / 2) - 65.5).toFixed(1)} x ${(H2 - 60).toFixed(1)}` });
    } else if (wings === 3) {
        let bottomTrack = type === 'door' ? '03524' : '03448';
        let trackDesc = type === 'door' ? 'מסילה תחתונה לדלת (3)' : 'מסילה תחתונה (3)';
        frame = [
            { desc: 'מסילה עליונה (3)', profile: '03446', qty: 1, cut: L - 27 },
            { desc: trackDesc, profile: bottomTrack, qty: 1, cut: L - 27 },
            { desc: 'מזוזה (3)', profile: '03447', qty: 2, cut: H },
        ];
        let sashWCut = rd((L / 3) + 5.4);
        let sashHCut = rd(type === 'door' ? H1 - 39.5 : H1 - 85.5);
        if (glassType !== '14-24') sashHCut = rd(sashHCut + 10.7);

        if (type === 'door' && widePanel) {
            sash.push({ desc: 'כנף עליון', profile: pSashTB, qty: 3, cut: sashWCut });
            sash.push({ desc: 'פנל תחתון רחב', profile: '06180', qty: 3, cut: sashWCut });
        } else {
            sash.push({ desc: 'כנף עליון/תחתון', profile: pSashTB, qty: 6, cut: sashWCut });
        }
        sash.push({ desc: 'כנף צד', profile: pSashSide, qty: 2, cut: sashHCut });
        sash.push({ desc: 'שולב', profile: pInterlock, qty: 4, cut: sashHCut });

        let glassH = (type === 'door' && widePanel) ? sashHCut - 106 : sashHCut - 12;
        glassParts.push({ desc: 'זכוכית כנף', qty: 3, text: `${(sashWCut - 66).toFixed(1)} x ${glassH.toFixed(1)}` });
    }

    let weight = 0;
    [...frame, ...fixedProfiles, ...sash, ...trims].forEach(item => {
        const kgPerMeter = PW_9000[item.profile] || 1.0;
        weight += (item.cut / 1000) * item.qty * kgPerMeter;
    });

    return {
        frame, fixedProfiles, sash, trims, glassParts, weight: weight.toFixed(2),
        frameW: frame.find(r => r.qty === 1)?.cut || frame[0]?.cut || 0,
        frameH: frame.find(r => r.qty === 2)?.cut || 0,
        sashW: sash[0]?.cut || 0,
        sashH: sash[1]?.cut || 0,
    };
}

// ────────────────────── Calculator Logic (7000) ──────────────────────
function calc7000(L, H, wings, glassType, shutter, fixedPart, H2, type = 'window', widePanel = false, hasScreen = false) {
    const H1 = fixedPart !== 'none' ? H - H2 : H;

    let pTopTrack, pBottomTrack, pJamb;
    let pSashTB, pSashSide, pInterlock;
    let trackCut = rd(L - 26);
    let sashWCut, sashHCut;
    let glassW, glassH;

    let frame = [], fixedProfiles = [], sash = [], glassParts = [];
    const trims = [
        { desc: 'הלבשה - רוחב', profile: '03358', qty: 2, cut: rd(L + 50) },
        { desc: 'הלבשה - גובה', profile: '03358', qty: 2, cut: rd(H + 50) },
    ];

    // Determine how many tracks are needed
    let trackCount = wings + (hasScreen ? 1 : 0);

    if (type === 'window') {
        if (trackCount <= 2) {
            pTopTrack = '03309'; pBottomTrack = '03307'; pJamb = glassType === '14' ? '03469' : '03308';
            sashHCut = rd(glassType === '14' ? H1 - 72.3 : H1 - 74.1);
        } else { // 3 tracks or more (Window + Screen)
            pTopTrack = '03317'; pBottomTrack = '03947'; pJamb = '03329';
            sashHCut = rd(H1 - 77); // As per catalog pg 8
        }
        pSashTB = glassType === '14' ? '03337' : '03304';
        pSashSide = glassType === '14' ? '03336' : '03303';
        pInterlock = glassType === '14' ? '03338' : '03305';

        sashWCut = rd(wings === 2 ? (L / 2) - 13.35 : (L / 3) + 5.4);
        glassW = rd(sashWCut - 56);
        glassH = rd(sashHCut - 56);

    } else { // door
        if (trackCount <= 2) {
            pTopTrack = '04193'; pBottomTrack = '03694'; pJamb = '03695';
            sashHCut = rd(H1 - 48); // As per catalog pg 34
        } else if (trackCount === 3) {
            pTopTrack = '04975'; pBottomTrack = '04741'; pJamb = '04974';
            sashHCut = rd(H1 - 57); // As per catalog pg 20
        } else { // 4 tracks
            pTopTrack = '04981'; pBottomTrack = '04982'; pJamb = '04980';
            sashHCut = rd(H1 - 37.7); // As per catalog pg 14
        }
        pSashTB = '04520';
        pSashSide = '04523';
        pInterlock = '04522';

        sashWCut = rd(wings === 2 ? (L / 2) - 13.65 : (L / 3) + 5.4);
        glassW = rd(sashWCut - 56.4);
        glassH = rd(widePanel ? sashHCut - 106 : sashHCut - 92);
    }

    // --- 1. Push Frame Profiles ---
    if (fixedPart === 'bottom' || fixedPart === 'top') {
        frame.push({ desc: 'מסילה עליונה', profile: pTopTrack, qty: 1, cut: trackCut });
        frame.push({ desc: 'חציץ מעבר לקבוע', profile: '04973', qty: 1, cut: rd(L - 26) });
        frame.push({ desc: 'מסילה תחתונה', profile: pBottomTrack, qty: 1, cut: trackCut });
        frame.push({ desc: 'מזוזה כולל קבוע', profile: pJamb, qty: 2, cut: H });
        fixedProfiles.push({ desc: 'קבוע צד', profile: '03836', qty: 2, cut: rd(H2 - 17) });
        sashHCut = rd(sashHCut - 8.3);
        glassH = rd(glassH - 8.3);
    } else {
        frame.push({ desc: 'מסילה עליונה', profile: pTopTrack, qty: 1, cut: trackCut });
        frame.push({ desc: type === 'door' ? 'מסילה רצפתית' : 'מסילה תחתונה', profile: pBottomTrack, qty: 1, cut: trackCut });
        frame.push({ desc: 'מזוזה (צדדים)', profile: pJamb, qty: 2, cut: H });
    }

    // --- 2. Push Glass Sash Profiles ---
    let qtyMultiplier = wings === 3 ? 3 : 2;
    if (type === 'door' && widePanel) {
        sash.push({ desc: 'כנף עליון (זכוכית)', profile: pSashTB, qty: qtyMultiplier, cut: sashWCut });
        sash.push({ desc: 'פנל תחתון רחב', profile: '06180', qty: qtyMultiplier, cut: sashWCut });
    } else {
        sash.push({ desc: 'כנף עליון/תחתון (זכוכית)', profile: pSashTB, qty: qtyMultiplier * 2, cut: sashWCut });
    }
    sash.push({ desc: 'כנף צד', profile: pSashSide, qty: 2, cut: sashHCut });
    sash.push({ desc: wings === 3 ? 'שולב פנימי/חיצוני' : 'שולב', profile: pInterlock, qty: wings === 3 ? 4 : 2, cut: sashHCut });

    // --- 3. Push Screen Profiles (If selected) ---
    if (hasScreen) {
        let screenTopBot = type === 'door' ? '03304' : '04520';
        let screenSide = type === 'door' ? '03303' : '04268';
        sash.push({ desc: 'כנף רשת - עליון/תחתון', profile: screenTopBot, qty: 2, cut: sashWCut });
        sash.push({ desc: 'כנף רשת - צד', profile: screenSide, qty: 2, cut: sashHCut });
    }

    // --- 4. Push Glass Data ---
    glassParts.push({ desc: 'זכוכית כנף', qty: wings, text: `${(glassW || 0).toFixed(1)} x ${(glassH || 0).toFixed(1)}` });
    if (fixedPart !== 'none') glassParts.push({ desc: 'זכוכית קבוע', qty: 2, text: `${rd((L / 2) - 65.5).toFixed(1)} x ${rd(H2 - 60).toFixed(1)}` });

    let weight = 0;
    [...frame, ...fixedProfiles, ...sash, ...trims].forEach(item => {
        const kgPerMeter = PW_7000[item.profile] || 0.850;
        weight += (item.cut / 1000) * item.qty * kgPerMeter;
    });

    return {
        frame, fixedProfiles, sash, trims, glassParts, weight: weight.toFixed(2),
        frameW: frame.find(r => r.qty === 1)?.cut || frame[0]?.cut || 0,
        frameH: frame.find(r => r.qty === 2)?.cut || 0,
        sashW: sash[0]?.cut || 0,
        sashH: sash[1]?.cut || 0,
    };
}

// ────────────────────── Main Component ──────────────────────

// Bar length in mm (6 meters)
const BAR_LENGTH = 6000;

// First Fit Decreasing bin packing: distribute cuts into 6m bars
// Merged profile weights for material weight calc
const ALL_WEIGHTS = { ...PW_1700, ...PW_9000, ...PW_7000 };

function optimizeCuts(allWindows) {
    const profileCuts = {};
    allWindows.forEach((w, wIdx) => {
        const allItems = [...w.data.frame, ...w.data.fixedProfiles, ...w.data.sash, ...w.data.trims];
        allItems.forEach(item => {
            const profiles = item.profile.split(' / ').map(p => p.trim());
            profiles.forEach(profile => {
                if (!profileCuts[profile]) profileCuts[profile] = [];
                for (let i = 0; i < item.qty; i++) {
                    profileCuts[profile].push({ cut: item.cut, window: wIdx + 1, desc: item.desc || '' });
                }
            });
        });
    });

    const result = {};
    Object.keys(profileCuts).sort().forEach(profile => {
        const cuts = profileCuts[profile].sort((a, b) => b.cut - a.cut);
        const bars = [];

        cuts.forEach(cutItem => {
            let placed = false;
            for (let b = 0; b < bars.length; b++) {
                if (bars[b].remaining >= cutItem.cut) {
                    bars[b].cuts.push(cutItem);
                    bars[b].remaining -= cutItem.cut;
                    placed = true;
                    break;
                }
            }
            if (!placed) {
                bars.push({ cuts: [cutItem], remaining: BAR_LENGTH - cutItem.cut });
            }
        });

        const totalLength = cuts.reduce((s, c) => s + c.cut, 0);
        const kgPerMeter = ALL_WEIGHTS[profile] || 0;
        // Weight = total bars × 6m × kg/m (ordering full bars)
        const orderWeight = (bars.length * (BAR_LENGTH / 1000) * kgPerMeter);

        result[profile] = {
            totalCuts: cuts.length,
            totalBars: bars.length,
            bars,
            totalLength,
            waste: bars.length * BAR_LENGTH - totalLength,
            kgPerMeter,
            orderWeight: orderWeight.toFixed(2),
        };
    });

    return result;
}
export default function NewProject() {
    const [projectName, setProjectName] = useState('');
    const [projectColor, setProjectColor] = useState('');
    const [windows, setWindows] = useState([]);
    const [printMode, setPrintMode] = useState('compact');

    // Editable order table
    const [orderRows, setOrderRows] = useState([]);
    const [showOrderEditor, setShowOrderEditor] = useState(false);
    const [addProfileInput, setAddProfileInput] = useState('');
    const [addProfileQty, setAddProfileQty] = useState(1);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);

    // Form state for adding a window
    const [system, setSystem] = useState('1700');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [wings, setWings] = useState(2);
    const [glassType, setGlassType] = useState('10-14');
    const [shutter, setShutter] = useState(false);
    const [fixedPart, setFixedPart] = useState('none');
    const [fixedHeight, setFixedHeight] = useState('');
    const [windowNote, setWindowNote] = useState('');
    const [openingType, setOpeningType] = useState('window');
    const [widePanel, setWidePanel] = useState(true);
    const [hasScreen, setHasScreen] = useState(false); // Screen toggle for 7000

    // Adjust glass defaults when system changes
    const handleSystemChange = (val) => {
        setSystem(val);
        if (val === '1700') { setGlassType('10-14'); setWings(2); setOpeningType('window'); }
        else if (val === '9000') { setGlassType('14-24'); setWings(2); }
        else if (val === '7000') { setGlassType('4-8'); setWings(2); }
    };

    const addWindow = () => {
        const L = parseFloat(width);
        const H = parseFloat(height);
        const H2 = parseFloat(fixedHeight) || 0;
        if (!L || !H) return;
        if (fixedPart !== 'none' && !H2) return;

        let data;
        if (system === '1700') {
            data = calc1700(L, H, wings, glassType, shutter, fixedPart, H2);
        } else if (system === '9000') {
            data = calc9000(L, H, wings, glassType, shutter, fixedPart, H2, openingType, widePanel);
        } else {
            data = calc7000(L, H, wings, glassType, shutter, fixedPart, H2, openingType, widePanel, hasScreen);
        }

        const H1 = fixedPart !== 'none' ? H - H2 : H;

        setWindows(prev => [...prev, {
            id: Date.now(),
            system,
            width: L,
            height: H,
            wings,
            glassType,
            shutter,
            fixedPart,
            fixedHeight: H2,
            H1,
            note: windowNote,
            openingType: (system === '9000' || system === '7000') ? openingType : 'window',
            widePanel: (system === '9000' || system === '7000') ? widePanel : false,
            hasScreen: system === '7000' ? hasScreen : false,
            data,
        }]);

        // Reset form
        setWidth(''); setHeight(''); setFixedHeight(''); setWindowNote('');
    };

    const removeWindow = (id) => {
        setWindows(prev => prev.filter(w => w.id !== id));
    };

    const totalWeight = windows.reduce((sum, w) => sum + parseFloat(w.data.weight), 0).toFixed(2);

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-50 rounded-xl shadow-lg mt-10 print:shadow-none print:bg-white print:mt-0 print:p-0" dir="rtl">

            {/* Print page margin */}
            <style>{`@media print { @page { margin-top: 15mm; margin-bottom: 10mm; } img { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }`}</style>

            <Link to="/professionals" className="inline-flex items-center gap-2 text-gray-500 hover:text-blue-700 mb-4 transition-colors font-bold print:hidden">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                חזרה למחשבונים
            </Link>

            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold text-blue-900 print:text-black">📐 פרויקט חדש</h2>
                {windows.length > 0 && (
                    <div className="flex gap-2 flex-wrap print:hidden">
                        <button
                            onClick={() => { setPrintMode('compact'); setTimeout(() => window.print(), 100); }}
                            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-md text-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            סיכום שורה
                        </button>
                        <button
                            onClick={() => { setPrintMode('detail'); setTimeout(() => window.print(), 100); }}
                            className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-md text-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                            </svg>
                            דוח מפורט
                        </button>
                        <button
                            onClick={() => { setPrintMode('materials'); setTimeout(() => window.print(), 100); }}
                            className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-md text-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            דווח חיתוך
                        </button>
                        <button
                            onClick={() => {
                                const optimized = optimizeCuts(windows);
                                const rows = Object.keys(optimized).map(profile => ({
                                    id: Date.now() + Math.random(),
                                    profile,
                                    qty: optimized[profile].totalBars,
                                    kgPerMeter: ALL_WEIGHTS[profile] || 0,
                                    weight: parseFloat(optimized[profile].orderWeight),
                                }));
                                setOrderRows(rows);
                                setShowOrderEditor(true);
                            }}
                            className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-md text-sm"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
                            </svg>
                            הזמנת אלומיניום
                        </button>
                    </div>
                )}
            </div>

            {/* Project Name & Color */}
            <div className="mb-6 print:hidden flex gap-4 items-end">
                <div className="flex-1">
                    <label className="block text-gray-700 font-bold mb-2">שם הפרויקט:</label>
                    <input type="text" value={projectName} onChange={(e) => setProjectName(e.target.value)}
                        className="border-2 border-blue-200 p-3 rounded-lg w-full outline-none"
                        placeholder="לדוגמה: פרויקט כהן - רמת גן" />
                </div>
                <div style={{ width: '200px' }}>
                    <label className="block text-gray-700 font-bold mb-2">צבע:</label>
                    <input type="text" value={projectColor} onChange={(e) => setProjectColor(e.target.value)}
                        className="border-2 border-amber-300 bg-amber-50 p-3 rounded-lg w-full outline-none font-bold"
                        placeholder="לבן, RAL 9016..." />
                </div>
            </div>

            {/* ── Add Window Form ── */}
            <div className="bg-white p-6 rounded-lg shadow-sm border mb-8 print:hidden">
                <h3 className="text-xl font-bold text-blue-800 mb-4">➕ הוסף חלון</h3>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">מערכת:</label>
                        <select value={system} onChange={(e) => handleSystemChange(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none cursor-pointer bg-white">
                            <option value="1700">קליל 1700 בלגי</option>
                            <option value="9000">קליל 9000 כבד</option>
                            <option value="7000">קליל 7000 קלאסי</option>
                        </select>
                    </div>
                    {(system === '9000' || system === '7000') && (
                        <div>
                            <label className="block text-gray-600 font-bold mb-1 text-sm">סוג פתח:</label>
                            <select value={openingType} onChange={(e) => setOpeningType(e.target.value)}
                                className="border-2 border-blue-400 bg-blue-50 p-2 rounded-lg w-full outline-none cursor-pointer font-bold">
                                <option value="window">חלון (מסילה רגילה)</option>
                                <option value="door">דלת (מסילה רצפתית)</option>
                            </select>
                        </div>
                    )}
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">רוחב (מ"מ):</label>
                        <input type="number" value={width} onChange={(e) => setWidth(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none" placeholder="1200" />
                    </div>
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">גובה (מ"מ):</label>
                        <input type="number" value={height} onChange={(e) => setHeight(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none" placeholder="1400" />
                    </div>
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">כנפיים:</label>
                        <select value={wings} onChange={(e) => setWings(Number(e.target.value))}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none cursor-pointer bg-white">
                            <option value={2}>2 כנפיים</option>
                            <option value={3}>3 כנפיים</option>
                            {system === '1700' && <option value={4}>4 כנפיים</option>}
                        </select>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">זכוכית:</label>
                        <select value={glassType} onChange={(e) => setGlassType(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none cursor-pointer bg-white">
                            {system === '1700' ? (
                                <>
                                    <option value="10-14">10-14 מ"מ (בידודית)</option>
                                    <option value="4-6">4-6 מ"מ (רגילה)</option>
                                </>
                            ) : system === '7000' ? (
                                <>
                                    <option value="4-8">4 עד 8 מ"מ (רגילה)</option>
                                    <option value="14">14 מ"מ (בידודית)</option>
                                </>
                            ) : (
                                <>
                                    <option value="14-24">14-24 מ"מ (בידודית חזקה)</option>
                                    <option value="6-8">6-8 מ"מ (רגילה)</option>
                                </>
                            )}
                        </select>
                    </div>
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">תריס:</label>
                        <select value={shutter} onChange={(e) => setShutter(e.target.value === 'true')}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none cursor-pointer bg-white">
                            <option value="false">ללא</option>
                            <option value="true">כולל תריס</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-gray-600 font-bold mb-1 text-sm">קבוע:</label>
                        <select value={fixedPart} onChange={(e) => setFixedPart(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none cursor-pointer bg-white">
                            <option value="none">ללא</option>
                            <option value="top">קבוע עליון</option>
                            <option value="bottom">קבוע תחתון</option>
                        </select>
                    </div>
                    {fixedPart !== 'none' && (
                        <div>
                            <label className="block text-gray-600 font-bold mb-1 text-sm">גובה קבוע (מ"מ):</label>
                            <input type="number" value={fixedHeight} onChange={(e) => setFixedHeight(e.target.value)}
                                className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none" placeholder="400" />
                        </div>
                    )}
                    {(system === '9000' || system === '7000') && openingType === 'door' && (
                        <div className="flex items-center gap-2 bg-yellow-50 p-2 rounded-lg border border-yellow-200">
                            <input type="checkbox" id="wpCheck" checked={widePanel} onChange={(e) => setWidePanel(e.target.checked)} className="w-5 h-5 cursor-pointer" />
                            <label htmlFor="wpCheck" className="text-gray-800 font-bold cursor-pointer text-sm">פנל תחתון רחב?</label>
                        </div>
                    )}
                    {system === '7000' && (
                        <div className="flex items-center gap-2 bg-green-50 p-2 rounded-lg border border-green-200">
                            <input type="checkbox" id="screenCheck" checked={hasScreen} onChange={(e) => setHasScreen(e.target.checked)} className="w-5 h-5 cursor-pointer" />
                            <label htmlFor="screenCheck" className="text-gray-800 font-bold cursor-pointer text-sm">כולל רשת הזזה?</label>
                        </div>
                    )}
                </div>

                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-gray-600 font-bold mb-1 text-sm">הערה (אופציונלי):</label>
                        <input type="text" value={windowNote} onChange={(e) => setWindowNote(e.target.value)}
                            className="border-2 border-blue-200 p-2 rounded-lg w-full outline-none" placeholder="חדר שינה, סלון..." />
                    </div>
                    <button onClick={addWindow}
                        className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-bold transition-colors shadow-md whitespace-nowrap">
                        ✚ הוסף
                    </button>
                </div>
            </div>

            {/* ── Print Header ── */}
            <div className={`hidden ${(printMode === 'detail' || printMode === 'materials' || printMode === 'order') ? '' : 'print:block'} mb-6 pb-4`} style={{ borderBottom: '3px solid #1e3a5f' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <img src="/assets/logo-circle.png" alt="Alum Nawatha" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
                        <div>
                            <h1 style={{ fontSize: '20pt', fontWeight: 'bold', color: '#1e3a5f', margin: 0, lineHeight: 1.2 }}>אלום נואטחה בע"מ</h1>
                            <p style={{ fontSize: '9pt', color: '#555', margin: '2px 0 0 0', letterSpacing: '2px' }}>ALUM NAWATHA LTD</p>
                            <p style={{ fontSize: '8pt', color: '#888', margin: '2px 0 0 0' }}>מערכות אלומיניום מתקדמות | טל: 052-878-4031</p>
                        </div>
                    </div>
                    <div style={{ textAlign: 'left', fontSize: '9pt', color: '#555' }}>
                        <div><b>תאריך:</b> {new Date().toLocaleDateString('he-IL')}</div>
                        <div><b>סה"כ חלונות:</b> {windows.length}</div>
                        <div><b>משקל כולל:</b> {totalWeight} ק"ג</div>
                        {projectColor && <div><b>צבע:</b> {projectColor}</div>}
                    </div>
                </div>
                <div style={{ textAlign: 'center', marginTop: '8px', fontSize: '14pt', fontWeight: 'bold', color: '#1e3a5f' }}>
                    {projectName || 'פרויקט חדש'} — סיכום חלונות {projectColor && `| צבע: ${projectColor}`}
                </div>
            </div>

            {/* ── Windows Table (always on screen + compact print) ── */}
            {windows.length > 0 && (
                <>
                    <div className={`bg-white rounded-lg shadow-sm border overflow-hidden print:border-none print:shadow-none ${(printMode === 'detail' || printMode === 'materials' || printMode === 'order') ? 'print:hidden' : ''}`}>
                        {/* Screen header */}
                        <div className="bg-gray-800 text-white p-4 rounded-t-lg print:hidden">
                            <h3 className="text-lg font-bold">
                                {projectName || 'פרויקט חדש'} — {windows.length} חלונות | {totalWeight} ק"ג
                            </h3>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-right border-collapse" style={{ fontSize: '11pt' }}>
                                <thead>
                                    <tr className="bg-blue-100 border-b-2 border-blue-200 text-blue-900 print:bg-gray-100 print:border-gray-400 print:text-black">
                                        <th className="p-2 text-center border-l print:border-gray-300" style={{ width: '40px' }}>#</th>
                                        <th className="p-2 border-l print:border-gray-300">מערכת</th>
                                        <th className="p-2 border-l print:border-gray-300">מידות (ר×ג)</th>
                                        <th className="p-2 border-l print:border-gray-300">כנפיים</th>
                                        <th className="p-2 border-l print:border-gray-300">מסגרת</th>
                                        <th className="p-2 border-l print:border-gray-300">כנף</th>
                                        <th className="p-2 border-l print:border-gray-300">זכוכית</th>
                                        <th className="p-2 border-l print:border-gray-300">משקל</th>
                                        <th className="p-2 border-l print:border-gray-300">הערה</th>
                                        <th className="p-2 print:hidden" style={{ width: '40px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {windows.map((w, idx) => (
                                        <tr key={w.id} className="border-b hover:bg-gray-50 print:border-gray-300">
                                            <td className="p-2 text-center font-bold text-gray-500 border-l print:border-gray-300">{idx + 1}</td>
                                            <td className="p-2 border-l print:border-gray-300">
                                                <span className={`inline-block px-2 py-0.5 rounded text-xs font-bold text-white ${w.system === '1700' ? 'bg-blue-600' : 'bg-orange-600'}`}>
                                                    {w.system}
                                                </span>
                                                {w.openingType === 'door' && <span className="block text-xs text-purple-600 font-bold mt-0.5">דלת</span>}
                                            </td>
                                            <td className="p-2 font-mono font-bold text-red-600 border-l print:border-gray-300 print:text-black whitespace-nowrap" dir="ltr">
                                                {w.width} × {w.height}
                                                {w.fixedPart !== 'none' && (
                                                    <div className="text-xs text-gray-500 font-normal">קבוע: {w.fixedHeight} | כנף: {w.H1}</div>
                                                )}
                                            </td>
                                            <td className="p-2 text-center border-l print:border-gray-300">
                                                {w.wings}
                                                {w.shutter && <span className="text-xs text-orange-600 block">+תריס</span>}
                                            </td>
                                            <td className="p-2 font-mono font-bold border-l print:border-gray-300 whitespace-nowrap text-center" dir="ltr">
                                                <span className="text-red-600 print:text-black">{w.data.frameW}</span>
                                                <span className="text-gray-400 mx-0.5">×</span>
                                                <span className="text-red-600 print:text-black">{w.data.frameH}</span>
                                            </td>
                                            <td className="p-2 font-mono font-bold border-l print:border-gray-300 whitespace-nowrap text-center" dir="ltr">
                                                <span className="text-red-600 print:text-black">{w.data.sashW}</span>
                                                <span className="text-gray-400 mx-0.5">×</span>
                                                <span className="text-red-600 print:text-black">{w.data.sashH}</span>
                                            </td>
                                            <td className="p-2 text-xs border-l print:border-gray-300" style={{ maxWidth: '140px' }} dir="ltr">
                                                {w.data.glassParts.map((g, i) => (
                                                    <div key={i} className="whitespace-nowrap">{g.qty}× <b className="font-mono">{g.text}</b></div>
                                                ))}
                                            </td>
                                            <td className="p-2 font-bold border-l print:border-gray-300 whitespace-nowrap">{w.data.weight} ק"ג</td>
                                            <td className="p-2 text-xs text-gray-500 border-l print:border-gray-300">{w.note}</td>
                                            <td className="p-2 text-center print:hidden">
                                                <button onClick={() => removeWindow(w.id)} className="text-red-400 hover:text-red-600 text-lg font-bold">✕</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-gray-800 text-white print:bg-gray-100 print:text-black print:border-t-2 print:border-gray-400">
                                        <td colSpan="7" className="p-3 font-bold text-lg">סה"כ — {windows.length} חלונות</td>
                                        <td className="p-3 font-bold text-lg text-yellow-400 print:text-black">{totalWeight} ק"ג</td>
                                        <td className="p-3 print:hidden" colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    {/* ── DETAILED PRINT VIEW: one full table per window ── */}
                    <div className={`hidden ${printMode === 'detail' ? 'print:block' : ''}`}>
                        {windows.map((w, idx) => (
                            <div key={w.id} style={{ pageBreakAfter: 'always', marginBottom: '20px' }}>
                                {/* Per-window header */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '3px solid #1e3a5f', paddingBottom: '10px', marginBottom: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <img src="/assets/logo-circle.png" alt="Logo" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                                        <div>
                                            <h1 style={{ fontSize: '16pt', fontWeight: 'bold', color: '#1e3a5f', margin: 0 }}>אלום נואטחה בע"מ</h1>
                                            <p style={{ fontSize: '8pt', color: '#888', margin: 0 }}>ALUM NAWATHA LTD | טל: 052-878-4031</p>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'left', fontSize: '9pt', color: '#555' }}>
                                        <div><b>תאריך:</b> {new Date().toLocaleDateString('he-IL')}</div>
                                        <div><b>פרויקט:</b> {projectName || 'פרויקט חדש'}</div>
                                        <div><b>חלון:</b> {idx + 1} / {windows.length}</div>
                                        {projectColor && <div><b>צבע:</b> {projectColor}</div>}
                                    </div>
                                </div>

                                {/* Window info bar */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#e8f0fe', padding: '8px 12px', borderRadius: '6px', marginBottom: '10px', fontSize: '11pt' }}>
                                    <div>
                                        <b style={{ color: '#1e3a5f', fontSize: '13pt' }}>חלון #{idx + 1}</b>
                                        {w.note && <span style={{ color: '#555', marginRight: '10px' }}> — {w.note}</span>}
                                    </div>
                                    <div style={{ display: 'flex', gap: '16px', fontSize: '10pt' }}>
                                        <span><b>מערכת:</b> קליל {w.system}</span>
                                        <span><b>מידות:</b> <span style={{ color: '#c00', fontFamily: 'monospace', fontWeight: 'bold' }}>{w.width} × {w.height}</span></span>
                                        <span><b>כנפיים:</b> {w.wings} {w.shutter ? '+ תריס' : ''}</span>
                                        <span><b>זכוכית:</b> {w.glassType} מ"מ</span>
                                    </div>
                                </div>
                                {w.fixedPart !== 'none' && (
                                    <div style={{ fontSize: '9pt', color: '#555', marginBottom: '8px', padding: '4px 12px', background: '#f5f5f5', borderRadius: '4px' }}>
                                        <b>קבוע {w.fixedPart === 'top' ? 'עליון' : 'תחתון'}:</b> {w.fixedHeight} מ"מ | <b>גובה כנף:</b> {w.H1} מ"מ
                                    </div>
                                )}

                                {/* Full cuts table */}
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10pt', textAlign: 'right', direction: 'rtl' }}>
                                    <thead>
                                        <tr style={{ background: '#1e3a5f', color: 'white' }}>
                                            <th style={{ padding: '6px 10px', borderLeft: '1px solid #2d5a8f' }}>תיאור</th>
                                            <th style={{ padding: '6px 10px', borderLeft: '1px solid #2d5a8f' }}>פרופיל</th>
                                            <th style={{ padding: '6px 10px', borderLeft: '1px solid #2d5a8f', textAlign: 'center' }}>כמות</th>
                                            <th style={{ padding: '6px 10px', textAlign: 'center' }}>מידת חיתוך</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ background: '#eef2f7' }}><td colSpan="4" style={{ padding: '4px 10px', fontWeight: 'bold', color: '#1e3a5f', fontSize: '11pt' }}>מסגרת</td></tr>
                                        {w.data.frame.map((r, i) => (
                                            <tr key={`fr-${i}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '5px 10px' }}>{r.desc || '-'}</td>
                                                <td style={{ padding: '5px 10px', fontFamily: 'monospace' }}><div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{r.profile.split(' / ').map(p => <img key={p} src={`/profiles/${p.trim()}.jpg`} alt={p} style={{ width: '28px', height: '28px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />)}<span>{r.profile}</span></div></td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold' }}>{r.qty}</td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold', fontFamily: 'monospace', color: '#c00', fontSize: '12pt' }}>{r.cut}</td>
                                            </tr>
                                        ))}
                                        {w.data.fixedProfiles.length > 0 && (
                                            <>
                                                <tr style={{ background: '#eef2f7' }}><td colSpan="4" style={{ padding: '4px 10px', fontWeight: 'bold', color: '#1e3a5f', fontSize: '11pt' }}>קבוע</td></tr>
                                                {w.data.fixedProfiles.map((r, i) => (
                                                    <tr key={`fp-${i}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                        <td style={{ padding: '5px 10px' }}>{r.desc || '-'}</td>
                                                        <td style={{ padding: '5px 10px', fontFamily: 'monospace' }}><div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{r.profile.split(' / ').map(p => <img key={p} src={`/profiles/${p.trim()}.jpg`} alt={p} style={{ width: '28px', height: '28px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />)}<span>{r.profile}</span></div></td>
                                                        <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold' }}>{r.qty}</td>
                                                        <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold', fontFamily: 'monospace', color: '#c00', fontSize: '12pt' }}>{r.cut}</td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                        <tr style={{ background: '#eef2f7' }}><td colSpan="4" style={{ padding: '4px 10px', fontWeight: 'bold', color: '#1e3a5f', fontSize: '11pt' }}>כנפיים</td></tr>
                                        {w.data.sash.map((r, i) => (
                                            <tr key={`s-${i}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '5px 10px' }}>{r.desc || '-'}</td>
                                                <td style={{ padding: '5px 10px', fontFamily: 'monospace' }}><div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{r.profile.split(' / ').map(p => <img key={p} src={`/profiles/${p.trim()}.jpg`} alt={p} style={{ width: '28px', height: '28px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />)}<span>{r.profile}</span></div></td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold' }}>{r.qty}</td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold', fontFamily: 'monospace', color: '#c00', fontSize: '12pt' }}>{r.cut}</td>
                                            </tr>
                                        ))}
                                        <tr style={{ background: '#eef2f7' }}><td colSpan="4" style={{ padding: '4px 10px', fontWeight: 'bold', color: '#1e3a5f', fontSize: '11pt' }}>הלבשות</td></tr>
                                        {w.data.trims.map((r, i) => (
                                            <tr key={`t-${i}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '5px 10px' }}>{r.desc || '-'}</td>
                                                <td style={{ padding: '5px 10px', fontFamily: 'monospace' }}><div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>{r.profile.split(' / ').map(p => <img key={p} src={`/profiles/${p.trim()}.jpg`} alt={p} style={{ width: '28px', height: '28px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />)}<span>{r.profile}</span></div></td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold' }}>{r.qty}</td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold', fontFamily: 'monospace', color: '#c00', fontSize: '12pt' }}>{r.cut}</td>
                                            </tr>
                                        ))}
                                        <tr style={{ background: '#eef2f7' }}><td colSpan="4" style={{ padding: '4px 10px', fontWeight: 'bold', color: '#1e3a5f', fontSize: '11pt' }}>זיגוג ({w.glassType} מ"מ)</td></tr>
                                        {w.data.glassParts.map((g, i) => (
                                            <tr key={`g-${i}`} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '5px 10px' }}>{g.desc}</td>
                                                <td style={{ padding: '5px 10px' }}>-</td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold' }}>{g.qty}</td>
                                                <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 'bold', fontFamily: 'monospace', color: '#0066cc', fontSize: '12pt' }}>{g.text}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{ marginTop: '8px', padding: '6px 12px', background: '#f3f3f3', textAlign: 'center', fontWeight: 'bold', fontSize: '11pt', borderRadius: '4px', border: '1px solid #ddd' }}>
                                    משקל אלומיניום מוערך: {w.data.weight} ק"ג
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {/* ── MATERIALS PRINT VIEW: profile optimization report ── */}
            {windows.length > 0 && (() => {
                const optimized = optimizeCuts(windows);
                const profiles = Object.keys(optimized);
                const totalBars = profiles.reduce((s, p) => s + optimized[p].totalBars, 0);
                const totalWaste = profiles.reduce((s, p) => s + optimized[p].waste, 0);
                const totalUsed = profiles.reduce((s, p) => s + optimized[p].totalLength, 0);
                const wastePercent = totalBars > 0 ? ((totalWaste / (totalBars * BAR_LENGTH)) * 100).toFixed(1) : 0;
                const totalOrderWeight = profiles.reduce((s, p) => s + parseFloat(optimized[p].orderWeight), 0).toFixed(1);

                return (
                    <div className={`hidden ${printMode === 'materials' ? 'print:block' : ''}`}>
                        {/* Materials Header */}
                        <div style={{ borderBottom: '3px solid #1e3a5f', paddingBottom: '10px', marginBottom: '16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <img src="/assets/logo-circle.png" alt="Logo" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                                    <div>
                                        <h1 style={{ fontSize: '16pt', fontWeight: 'bold', color: '#1e3a5f', margin: 0 }}>אלום נואטחה בע"מ</h1>
                                        <p style={{ fontSize: '8pt', color: '#888', margin: 0 }}>ALUM NAWATHA LTD | טל: 052-878-4031</p>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'left', fontSize: '9pt', color: '#555' }}>
                                    <div><b>תאריך:</b> {new Date().toLocaleDateString('he-IL')}</div>
                                    <div><b>פרויקט:</b> {projectName || 'פרויקט חדש'}</div>
                                    <div><b>חלונות:</b> {windows.length}</div>
                                    {projectColor && <div><b>צבע:</b> {projectColor}</div>}
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '8px', fontSize: '14pt', fontWeight: 'bold', color: '#1e3a5f' }}>
                                דווח חיתוך — אופטימיזציה לפרופילים (6 מטר)
                            </div>
                        </div>

                        {/* Summary Box */}
                        <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', fontSize: '10pt' }}>
                            <div style={{ flex: 1, background: '#eef2f7', padding: '10px 14px', borderRadius: '6px', textAlign: 'center', border: '1px solid #d0d8e4' }}>
                                <div style={{ fontSize: '20pt', fontWeight: 'bold', color: '#1e3a5f' }}>{totalBars}</div>
                                <div style={{ color: '#555' }}>פרופילים (6 מטר)</div>
                            </div>
                            <div style={{ flex: 1, background: '#eef2f7', padding: '10px 14px', borderRadius: '6px', textAlign: 'center', border: '1px solid #d0d8e4' }}>
                                <div style={{ fontSize: '20pt', fontWeight: 'bold', color: '#1e3a5f' }}>{profiles.length}</div>
                                <div style={{ color: '#555' }}>סוגי פרופיל</div>
                            </div>
                            <div style={{ flex: 1, background: '#eef2f7', padding: '10px 14px', borderRadius: '6px', textAlign: 'center', border: '1px solid #d0d8e4' }}>
                                <div style={{ fontSize: '20pt', fontWeight: 'bold', color: '#1e3a5f' }}>{(totalUsed / 1000).toFixed(1)}m</div>
                                <div style={{ color: '#555' }}>ניצול כולל</div>
                            </div>
                            <div style={{ flex: 1, background: wastePercent > 20 ? '#fef2f2' : '#f0fdf4', padding: '10px 14px', borderRadius: '6px', textAlign: 'center', border: `1px solid ${wastePercent > 20 ? '#fecaca' : '#bbf7d0'}` }}>
                                <div style={{ fontSize: '20pt', fontWeight: 'bold', color: wastePercent > 20 ? '#dc2626' : '#16a34a' }}>{wastePercent}%</div>
                                <div style={{ color: '#555' }}>פחת</div>
                            </div>
                            <div style={{ flex: 1, background: '#fff7ed', padding: '10px 14px', borderRadius: '6px', textAlign: 'center', border: '1px solid #fed7aa' }}>
                                <div style={{ fontSize: '20pt', fontWeight: 'bold', color: '#c2410c' }}>{totalOrderWeight}</div>
                                <div style={{ color: '#555' }}>משקל כולל (ק"ג)</div>
                            </div>
                        </div>

                        {/* Per-Profile Tables */}
                        {profiles.map(profile => {
                            const data = optimized[profile];
                            return (
                                <div key={profile} style={{ marginBottom: '20px', breakInside: 'avoid', pageBreakInside: 'avoid' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#1e3a5f', color: 'white', padding: '6px 12px', borderRadius: '6px 6px 0 0' }}>
                                        <img src={`/profiles/${profile}.jpg`} alt={profile} style={{ width: '30px', height: '30px', objectFit: 'contain', background: 'white', borderRadius: '4px', padding: '2px' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                        <span style={{ fontFamily: 'monospace', fontSize: '13pt', fontWeight: 'bold' }}>{profile}</span>
                                        <span style={{ fontSize: '9pt', opacity: 0.8 }}>—</span>
                                        <span style={{ fontSize: '10pt' }}>{data.totalBars} פרופילים × 6m</span>
                                        <span style={{ fontSize: '9pt', opacity: 0.8 }}>({data.totalCuts} חיתוכים)</span>
                                        <span style={{ fontSize: '10pt', marginRight: 'auto', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '4px' }}>{data.orderWeight} ק"ג</span>
                                    </div>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '9pt', direction: 'ltr', border: '2px solid #1e3a5f' }}>
                                        <thead>
                                            <tr style={{ background: '#e8f0fe' }}>
                                                <th style={{ padding: '4px 8px', border: '2px solid #1e3a5f', width: '50px', textAlign: 'center' }}>Bar #</th>
                                                <th style={{ padding: '4px 8px', border: '2px solid #1e3a5f', textAlign: 'left' }}>Cuts (mm)</th>
                                                <th style={{ padding: '4px 8px', border: '2px solid #1e3a5f', width: '70px', textAlign: 'center' }}>Used</th>
                                                <th style={{ padding: '4px 8px', border: '2px solid #1e3a5f', width: '70px', textAlign: 'center' }}>Waste</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.bars.map((bar, bIdx) => {
                                                const used = BAR_LENGTH - bar.remaining;
                                                const usedPct = ((used / BAR_LENGTH) * 100).toFixed(0);
                                                return (
                                                    <tr key={bIdx} style={{ borderBottom: '1px solid #ccc' }}>
                                                        <td style={{ padding: '5px 8px', textAlign: 'center', fontWeight: 'bold', color: '#1e3a5f' }}>{bIdx + 1}</td>
                                                        <td style={{ padding: '5px 8px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                                                                {bar.cuts.map((c, cIdx) => (
                                                                    <span key={cIdx} style={{ background: '#dbeafe', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: 'bold', fontSize: '10pt', whiteSpace: 'nowrap' }}>
                                                                        {c.cut}
                                                                        <span style={{ fontSize: '7pt', color: '#666', marginLeft: '2px' }}>w{c.window}</span>
                                                                    </span>
                                                                ))}
                                                            </div>
                                                            {/* Visual bar */}
                                                            <div style={{ marginTop: '3px', background: '#e5e7eb', borderRadius: '3px', height: '8px', width: '100%', position: 'relative', overflow: 'hidden' }}>
                                                                <div style={{ height: '100%', borderRadius: '3px', background: usedPct > 90 ? '#16a34a' : usedPct > 70 ? '#2563eb' : '#f59e0b', width: `${usedPct}%` }} />
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '5px 8px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold' }}>{used}<span style={{ fontSize: '7pt', color: '#888' }}> ({usedPct}%)</span></td>
                                                        <td style={{ padding: '5px 8px', textAlign: 'center', fontFamily: 'monospace', color: bar.remaining > 1000 ? '#dc2626' : '#888' }}>{bar.remaining}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        })}
                    </div>
                );
            })()}

            {/* ── EDITABLE ORDER EDITOR (on screen) ── */}
            {showOrderEditor && (
                <div className="bg-white rounded-lg shadow-lg border-2 border-purple-300 p-6 mb-8 print:hidden" dir="rtl">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-xl font-bold text-purple-800">📝 עריכת הזמנה — ערוך לפני הדפסה</h3>
                        <div className="flex gap-2">
                            <button onClick={() => { setPrintMode('order'); setTimeout(() => window.print(), 100); }}
                                className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-lg font-bold shadow-md">
                                🖨️ הדפס הזמנה
                            </button>
                            <button onClick={() => setShowOrderEditor(false)}
                                className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded-lg font-bold">
                                סגור
                            </button>
                        </div>
                    </div>

                    {/* Editable Table */}
                    <table className="w-full border-collapse text-sm mb-4">
                        <thead>
                            <tr className="bg-purple-800 text-white">
                                <th className="p-2 border border-purple-600 w-10">#</th>
                                <th className="p-2 border border-purple-600">תמונה</th>
                                <th className="p-2 border border-purple-600">מק"ט פרופיל</th>
                                <th className="p-2 border border-purple-600 w-24">כמות (6מ)</th>
                                <th className="p-2 border border-purple-600 w-24">משקל (ק"ג)</th>
                                <th className="p-2 border border-purple-600 w-12 print:hidden"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderRows.map((row, idx) => (
                                <tr key={row.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                    <td className="p-2 border text-center font-bold text-gray-500">{idx + 1}</td>
                                    <td className="p-2 border text-center">
                                        <img src={`/profiles/${row.profile}.jpg`} alt={row.profile}
                                            className="mx-auto" style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                            onError={(e) => { e.target.style.display = 'none'; }} />
                                    </td>
                                    <td className="p-2 border text-center font-mono font-bold text-blue-900 text-lg">{row.profile}</td>
                                    <td className="p-2 border text-center">
                                        <input type="number" value={row.qty} min="0"
                                            onChange={(e) => {
                                                const val = parseInt(e.target.value) || 0;
                                                setOrderRows(prev => prev.map(r => r.id === row.id ? {
                                                    ...r,
                                                    qty: val,
                                                    weight: parseFloat((val * 6 * r.kgPerMeter).toFixed(2)),
                                                } : r));
                                            }}
                                            className="w-16 text-center border-2 border-purple-300 rounded-lg p-1 font-bold text-lg text-red-600 outline-none" />
                                    </td>
                                    <td className="p-2 border text-center font-mono font-bold">{row.weight}</td>
                                    <td className="p-2 border text-center">
                                        <button onClick={() => setOrderRows(prev => prev.filter(r => r.id !== row.id))}
                                            className="text-red-400 hover:text-red-600 text-lg font-bold">✕</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-purple-800 text-white font-bold">
                                <td colSpan="3" className="p-2 text-center">סה"כ</td>
                                <td className="p-2 text-center text-lg">{orderRows.reduce((s, r) => s + r.qty, 0)}</td>
                                <td className="p-2 text-center">{orderRows.reduce((s, r) => s + r.weight, 0).toFixed(1)} ק"ג</td>
                                <td className="p-2"></td>
                            </tr>
                        </tfoot>
                    </table>

                    {/* Add Row */}
                    <div className="flex gap-3 items-end bg-purple-50 p-4 rounded-lg border border-purple-200">
                        <div className="flex-1">
                            <label className="block text-purple-800 font-bold mb-1 text-sm">הוסף פרופיל:</label>
                            <div className="flex gap-2">
                                {/* Custom dropdown with images */}
                                <div className="relative flex-1">
                                    <button
                                        type="button"
                                        onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                                        className="border-2 border-purple-300 p-2 rounded-lg w-full outline-none bg-white font-mono text-right flex items-center justify-between gap-2"
                                    >
                                        {addProfileInput ? (
                                            <span className="flex items-center gap-2">
                                                <img src={`/profiles/${addProfileInput}.jpg`} alt="" style={{ width: '28px', height: '28px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                                <span className="font-bold">{addProfileInput}</span>
                                            </span>
                                        ) : (
                                            <span className="text-gray-400">בחר מהרשימה...</span>
                                        )}
                                        <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                                    </button>
                                    {showProfileDropdown && (
                                        <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-white border-2 border-purple-300 rounded-lg shadow-xl max-h-64 overflow-y-auto">
                                            {Object.keys(ALL_WEIGHTS).sort().map(p => (
                                                <button
                                                    key={p}
                                                    type="button"
                                                    onClick={() => { setAddProfileInput(p); setShowProfileDropdown(false); }}
                                                    className="w-full flex items-center gap-3 px-3 py-2 hover:bg-purple-50 transition-colors text-right border-b border-gray-100 last:border-0"
                                                >
                                                    <img src={`/profiles/${p}.jpg`} alt={p} style={{ width: '36px', height: '36px', objectFit: 'contain', flexShrink: 0 }} onError={(e) => { e.target.style.visibility = 'hidden'; }} />
                                                    <span className="font-mono font-bold text-blue-900">{p}</span>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <span className="text-gray-400 self-center font-bold">או</span>
                                <input type="text" placeholder="מקט חופשי"
                                    value={addProfileInput}
                                    onChange={(e) => { setAddProfileInput(e.target.value); setShowProfileDropdown(false); }}
                                    className="border-2 border-purple-300 p-2 rounded-lg w-32 outline-none font-mono" />
                            </div>
                        </div>
                        <div>
                            <label className="block text-purple-800 font-bold mb-1 text-sm">כמות:</label>
                            <input type="number" value={addProfileQty} min="1"
                                onChange={(e) => setAddProfileQty(parseInt(e.target.value) || 1)}
                                className="border-2 border-purple-300 p-2 rounded-lg w-20 outline-none font-bold text-center" />
                        </div>
                        <button
                            onClick={() => {
                                if (!addProfileInput.trim()) return;
                                const kg = ALL_WEIGHTS[addProfileInput.trim()] || 0;
                                setOrderRows(prev => [...prev, {
                                    id: Date.now() + Math.random(),
                                    profile: addProfileInput.trim(),
                                    qty: addProfileQty,
                                    kgPerMeter: kg,
                                    weight: parseFloat((addProfileQty * 6 * kg).toFixed(2)),
                                }]);
                                setAddProfileInput('');
                                setAddProfileQty(1);
                            }}
                            className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-lg font-bold shadow-md"
                        >
                            + הוסף
                        </button>
                    </div>
                </div>
            )}

            {/* ── ORDER PRINT VIEW: reads from orderRows ── */}
            {orderRows.length > 0 && (() => {
                const totalBars = orderRows.reduce((s, r) => s + r.qty, 0);
                const totalOrderWeight = orderRows.reduce((s, r) => s + r.weight, 0).toFixed(1);

                return (
                    <div className={`hidden ${printMode === 'order' ? 'print:block' : ''}`}>
                        {/* Order Header */}
                        <div style={{ borderBottom: '3px solid #1e3a5f', paddingBottom: '10px', marginBottom: '16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <img src="/assets/logo-circle.png" alt="Logo" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                                    <div>
                                        <h1 style={{ fontSize: '16pt', fontWeight: 'bold', color: '#1e3a5f', margin: 0 }}>אלום נואטחה בע"מ</h1>
                                        <p style={{ fontSize: '8pt', color: '#888', margin: 0 }}>ALUM NAWATHA LTD | טל: 052-878-4031</p>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'left', fontSize: '9pt', color: '#555' }}>
                                    <div><b>תאריך:</b> {new Date().toLocaleDateString('he-IL')}</div>
                                    <div><b>פרויקט:</b> {projectName || 'פרויקט חדש'}</div>
                                    {projectColor && <div><b>צבע:</b> {projectColor}</div>}
                                    <div><b>חלונות:</b> {windows.length}</div>
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '8px', fontSize: '14pt', fontWeight: 'bold', color: '#1e3a5f' }}>
                                הזמנת פרופילים {projectColor && `| צבע: ${projectColor}`}
                            </div>
                        </div>

                        {/* Order Table */}
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11pt', direction: 'rtl', border: '2px solid #1e3a5f' }}>
                            <thead>
                                <tr style={{ background: '#1e3a5f', color: 'white' }}>
                                    <th style={{ padding: '8px 12px', border: '2px solid #1e3a5f', width: '50px', textAlign: 'center' }}>#</th>
                                    <th style={{ padding: '8px 12px', border: '2px solid #1e3a5f', width: '120px', textAlign: 'center' }}>תמונה</th>
                                    <th style={{ padding: '8px 12px', border: '2px solid #1e3a5f', textAlign: 'center' }}>מק"ט פרופיל</th>
                                    <th style={{ padding: '8px 12px', border: '2px solid #1e3a5f', width: '100px', textAlign: 'center' }}>כמות (6 מטר)</th>
                                    <th style={{ padding: '8px 12px', border: '2px solid #1e3a5f', width: '100px', textAlign: 'center' }}>משקל (ק"ג)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderRows.map((row, idx) => (
                                    <tr key={row.id} style={{ borderBottom: '1px solid #ccc', background: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                                        <td style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 'bold', color: '#1e3a5f' }}>{idx + 1}</td>
                                        <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                                            <img src={`/profiles/${row.profile}.jpg`} alt={row.profile} style={{ width: '60px', height: '60px', minWidth: '60px', minHeight: '60px', objectFit: 'contain', margin: '0 auto', display: 'block' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                        </td>
                                        <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: 'monospace', fontSize: '14pt', fontWeight: 'bold', color: '#1e3a5f' }}>{row.profile}</td>
                                        <td style={{ padding: '8px 12px', textAlign: 'center', fontSize: '16pt', fontWeight: 'bold', color: '#c00' }}>{row.qty}</td>
                                        <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold' }}>{row.weight}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr style={{ background: '#1e3a5f', color: 'white', fontWeight: 'bold' }}>
                                    <td colSpan="3" style={{ padding: '8px 12px', textAlign: 'center', fontSize: '12pt' }}>סה"כ</td>
                                    <td style={{ padding: '8px 12px', textAlign: 'center', fontSize: '16pt' }}>{totalBars}</td>
                                    <td style={{ padding: '8px 12px', textAlign: 'center', fontSize: '12pt' }}>{totalOrderWeight} ק"ג</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                );
            })()}

            {windows.length === 0 && (
                <div className="text-center text-gray-400 py-16 print:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto mb-4 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    <p className="text-lg font-bold">הוסף חלונות לפרויקט</p>
                    <p className="text-sm mt-1">בחר מערכת, הזן מידות והוסף</p>
                </div>
            )}
        </div>
    );
}
